import { render } from "./OptionService.vue?vue&type=template&id=61bf87f5"
import script from "./OptionService.vue?vue&type=script&lang=js"
export * from "./OptionService.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__